import { render } from "./ExtraQuestionTextBox.vue?vue&type=template&id=fc2a2d86&scoped=true"
import script from "./ExtraQuestionTextBox.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionTextBox.vue?vue&type=script&lang=js"

import "./ExtraQuestionTextBox.vue?vue&type=style&index=0&id=fc2a2d86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc2a2d86"]])

export default __exports__